// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"3d083ab6","453":"6f7e7593"}[chunkId] + ".chunk.js";
};